import {AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {AutoCadService} from "../../services/CADService/auto-cad.service";
import {animateShow} from "../../animations/showHideAnimation";
import {CadMarker} from "../../models/CadMarker";
import {EsBsModalService} from "../../services/bsModalService/bs-modal.service";
import * as WZoomPlugin from 'vanilla-js-wheel-zoom';
import {HintManagerService} from "../../services/hintManager/hint-manager.service";

@Component({
  selector: 'app-cad-auto-import-modal',
  templateUrl: './cad-auto-import-modal.component.html',
  styleUrls: ['./cad-auto-import-modal.component.scss'],
  animations: [animateShow]
})

export class CadAutoImportModalComponent implements OnInit, AfterViewInit{
  @ViewChild('imgContainer', {static: false}) img;

  Yiit = Yiit;
  private markers: CadMarker[];
  private WZoom = WZoomPlugin.default;
  private wZoomImg = null;
  private isMouseMoved = false;
  public currentImgScale = 1;

  isCadModalOpened: boolean;

  constructor(
    private cad: AutoCadService,
    private bsModal: EsBsModalService,
    private cd: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    // this.bsModal.currentModalUpdate.subscribe((modalName)=>{
    //   this.isCadModalOpened = this.bsModal.currentModal == '#cad-auto-import-modal';
    //   this.cd.detectChanges();
    // });
    //
    // this.cad.markersUpdated.subscribe((markers)=>{
    //   this.markers = markers;
    // });
    //
    // // const wzoom = WZoom.create('img');
    // window['wZoom'] = this.WZoom;
  }

  ngAfterViewInit(): void {
    // let self = this;
    // this.cad.cadUrlChanged$.subscribe((url:any)=>{
      // let newImg = new Image();
      // newImg.src = url;
      // newImg.onload = function () {
        // if (self.wZoomImg){
        //   self.wZoomImg.destroy();
        // }
        // setTimeout(()=>{
        //   self.wZoomImg = self.WZoom.create('.es-cad-image-container', {
        //     type: 'html',
        //     width: newImg.width,
        //     height: newImg.height,
        //     minScale: null,
        //     maxScale: 2,
        //     zoomOnClick: false,
        //     dragScrollableOptions: {
        //       smoothExtinction: 0,
        //       onMove: ()=>{self.isMouseMoved = true;},
        //     },
        //     rescale: ()=>{
        //       self.currentImgScale = self.wZoomImg.content.currentScale;
        //       self.cd.detectChanges();
        //     }
        //   });
        //   console.log('this.wZoomImg', self.wZoomImg);
        // }, 500);
      // };
    //
    // })
  }

  getCADImage(){
    return this.cad.currentCADUrl;
  }

  cancelSync(){
    this.cad.clearMarkers();
  }

  continueProcessMarkers(){
    if (this.markers.length >= 3){
      this.bsModal.closeModal();
     return this.cad.enableMapMarkersProcessStatus();
    }
    alert('You didn\'t select 3 positions for markers');
  }

  addNewMarker(event){
    if (this.isMouseMoved){
      this.isMouseMoved = false;
      return;
    }
    let imgPosition = {left: (event.offsetX/this.img.nativeElement.clientWidth)*100, top: (event.offsetY/this.img.nativeElement.clientHeight)*100};
    this.cad.addMarker({imgPosition});
  }

}
